import React, { Component } from "react";
import Scheduling from "../../../components/Scheduling/Scheduling";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ASchedulingForm
Description : Componente que invoca al componente Scheduling.
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class SchedulingForm extends Component {
    render() {
        return (
            <Scheduling />
        )
    }
}

export default SchedulingForm;